
import { Editor } from "@tiptap/react";
import { ToolbarControls } from "./components/ToolbarControls";
import { ImageUploadControls } from "./components/ImageUploadControls";

interface EditorToolbarProps {
  editor: Editor;
}

const EditorToolbar = ({ editor }: EditorToolbarProps) => {
  return (
    <div className="border-b p-2 bg-white flex flex-wrap gap-1 items-center">
      <ToolbarControls editor={editor} />
      <div className="h-4 w-px bg-gray-200 mx-1" />
      <ImageUploadControls editor={editor} />
    </div>
  );
};

export default EditorToolbar;
